import projectData from "../data/projectData";

export default function ProjectList() {
  return (
    <div className="">
      {projectData.map((project, index) => (
        <div key={index}>
          {index % 2 === 0 ? (
            <div className="mx-auto grid max-w-2xl grid-cols-1 items-center gap-x-8 gap-y-16 py-24 sm:px-6 sm:py-32 lg:max-w-7xl lg:grid-cols-2 ">
              <img
                src={project.imageSrc}
                alt="Project"
                className="rounded-3xl bg-gray-100"
                data-aos="zoom-out-right"
                data-aos-duration="1500"
              />
              <div>
                <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
                  {project.title}
                </h2>
                <p className="mt-4 ">{project.description}</p>
                <div className="mt-10 flex gap-x-6">
                  <a
                    href={project.link}
                    className="rounded-md outline-2 italic outline-gray-900 px-3.5 py-2.5 text-sm font-semibold text-gray duration-1000 hover:bg-gray-100 hover:text-black"
                  >
                    자세히 보기
                  </a>
                </div>
              </div>
            </div>
          ) : (
            <div className="mx-auto grid max-w-2xl grid-cols-1 items-center gap-x-8 gap-y-16 px-4 py-24 sm:px-6 sm:py-32 lg:max-w-7xl lg:grid-cols-2 lg:px-8">
              <div>
                <h2 className="text-3xl font-bold tracking-tight  sm:text-4xl">
                  {project.title}
                </h2>
                <p className="mt-4 text-gray-500">{project.description}</p>
                <div className="mt-10 flex gap-x-6">
                  <a
                    href={project.link}
                    className="rounded-md outline-2 italic outline-gray-900 px-3.5 py-2.5 text-sm font-semibold text-gray duration-1000 hover:bg-gray-100 hover:text-black"
                  >
                    자세히 보기
                  </a>
                </div>
              </div>
              <img
                src={project.imageSrc}
                alt="Project"
                className="rounded-3xl bg-gray-100"
                data-aos="zoom-out-left"
                data-aos-duration="1500"
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
